// src/components/AboutFund.jsx
import React from 'react';

const AboutFund = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
      <h3 className="font-bold text-blue-800 mb-2 text-lg">About YildX</h3>
      <p className="text-gray-700 mb-2">
        YildX is a decentralized asset management platform offering tokenized crypto index funds. 
        It is designed to provide investors with diversified exposure to digital assets through a simple, transparent, and fully automated structure.
      </p>
      <p className="text-gray-700 mb-2">
        <strong>MCIF</strong>, the platform’s flagship token, represents a fractional share of the underlying assets held within the fund. 
        These assets are allocated across a curated basket of cryptocurrencies and rebalanced according to a predefined strategy.
      </p>
      <p className="text-gray-700">
        <strong>How it works:</strong> Deposit ETH into the YildX smart contract to mint MCIF tokens. 
        The smart contract then allocates funds according to the index strategy. 
        Investors can redeem MCIF at any time to withdraw their proportional share of the fund’s holdings.
      </p>
    </div>
  );
};

export default AboutFund;